import http from '@/api/common'

export default {
  getDashboard (params) {
    return http.get('building/get', params)
  }
}



// WEBPACK FOOTER //
// ./src/api/endpoints/lookup.js